<template>
  <div id="books_children" class="grid grid--wide" data-test="myhome__children-books-container">
    <div v-if="showChildren" class="xs-12 myhome-home__children-section">
      <div class="myhome-home__mybooks-header">
        <h2 class="dea-heading--medium__l" data-test="myhome__children-books-title">La mia famiglia</h2>
      </div>
      <div class="grid grid--wide myhome-home__children-cards">
        <CardChild
          v-for="(child, index) in user.children_data"
          :key="`child-${index}`"
          :user="child"
          :links-color="user.targetCss.colorMod"
          @open-profile-modal="$emit('open-profile-modal', $event)"
        />
      </div>
    </div>
    <div v-if="flatChildrenBooks.length" class="xs-12 myhome-home__children-books-section">
      <div class="myhome-home__mybooks-header">
        <h2 class="dea-heading--medium__l" data-test="myhome__children-books-title">I libri della mia famiglia</h2>
      </div>
      <LightTabContainer ref="tabBooks" class="children-books grid grid--wide">
        <template v-for="(item, key, index) in user.children_map">
          <LightTabChild
            v-if="childrenBooks[key]"
            :id="index"
            :ref="`light-tab-${index}`"
            slot="header"
            :key="`names-${key}`"
            :label="tabLabel(index, item)"
            :target-border="selectedTabId === index ? user.targetCss.borderMod : 'dea-border-target-generic'"
            :selected-tab-id="selectedTabId"
            :select-method="openTab"
          />
        </template>
        <div
          v-for="(item, key, index) in user.children_map"
          :id="`tab-content-${index}`"
          slot="content"
          :key="`books-${key}`"
          class="dea-tabs-content"
        >
          <ActivatedBooksList
            v-if="childrenBooks[key]"
            :id="key"
            :async-conf="$root.asyncConf"
            :child="key"
            :child-name="item"
            :link-minisite="true"
            :books="childrenBooks[key]"
            :list-columns="12"
            columns-class="bookslist__column bookslist__column--myhome"
            :grid-wide="true"
            :show-catalog-link="true"
            :link-color="user.targetCss.colorMod"
            :student="true"
            @open-child-book="openChildBook"
            @save-bookmark="addBookmark"
            @delete-bookmark="removeBookmark"
            @update-books-list="$emit('update-books-list')"
          />
        </div>
      </LightTabContainer>
    </div>
    <EmptyHome
      v-else
      :link-color="user.targetCss.colorMod"
      :parent="user.parent"
      :student="user.student"
      :user="user"
      @open-activation-modal="$emit('open-activation-modal')"
      @open-evaluation-modal="$emit('open-evaluation-modal')"
    />
    <ChildrenModal
      v-if="modalVisible"
      :visible="modalVisible"
      :user="user"
      :local-user="localUser"
      :book-title="bookTitle"
      @confirm-open-child-book="confirmOpenChildBook"
      @close-modal="modalVisible = false"
    />
  </div>
</template>

<script>
import switchChildrenUser from "@/components/mixins/switchChildrenUser";
import LightTabContainer from "@/components/elements/LightTabContainer";
import ActivatedBooksList from "~/components/books/components/ActivatedBooksList";
import ChildrenModal from "~/components/books/components/ChildrenModal";
import LightTabChild from "~/components/books/components/LightTabChild";
import CardChild from "~/components/books/components/CardChild";
import EmptyHome from "~/components/books/components/EmptyHome";
import BookmarkActions from "~/components/bookmarks/mixins/BookmarkActions";

export default {
  name: "HomeFamilyBooks",
  components: {
    ActivatedBooksList,
    CardChild,
    ChildrenModal,
    LightTabContainer,
    LightTabChild,
    EmptyHome,
  },
  mixins: [BookmarkActions, switchChildrenUser],
  props: {
    books: {
      type: Array,
      required: true,
    },
    aed: {
      type: Array,
      required: true,
    },
    childrenBooks: {
      type: Object,
      required: true,
    },
    childrenAed: {
      type: Object,
      required: true,
    },
    showChildren: {
      type: Boolean,
      default: false,
    },
    loaded: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      modalVisible: false,
      localUser: null,
      localBook: null,
      localChild: null,
      bookTitle: null,
      selectedTabId: null,
    };
  },
  computed: {
    flatChildrenBooks() {
      let books = [];
      if (this.childrenBooks) {
        // eslint-disable-next-line no-restricted-syntax
        for (const child in this.childrenBooks) {
          if (Object.prototype.hasOwnProperty.call(this.childrenBooks, child))
            books = books.concat(this.childrenBooks[child]);
        }
      }
      return books;
    },
  },

  methods: {
    openTab(event, id) {
      this.$refs.tabBooks.openTab(event);
      this.selectedTabId = id;
    },
    openChildBook(child, book) {
      this.modalVisible = true;
      this.localUser = this.user.children_map[child];
      this.localBook = book;
      this.localChild = child;
      this.bookTitle = book.title;
    },
    confirmOpenChildBook() {
      let link = null;
      if (this.localBook.minisite_url.indexOf("http") === -1) {
        link = `${document.location.protocol}//${document.location.host}${this.localBook.minisite_url}`;
      } else {
        link = this.localBook.minisite_url;
      }
      this.fetchChild(this.$root.config.parent_login, this.localChild, link);
    },
    tabLabel(id, name) {
      return this.selectedTabId === id ? `Libri di ${name}` : `Vai ai libri di ${name}`;
    },
  },
};
</script>

<style lang="scss">
@import "~deascuola-storybook/src/styles/system.utils";

.wait {
  cursor: wait;
}
</style>
